import { Dataset } from "@mui/icons-material";
import {
  addDocument,
  getDocumentDetails,
  deleteDocumentFile,
  downloadDocumentFile,
  addDataSets,
  getDataSet,
  deleteDataSet,
  allDatasetUsers,
  allDocumentUsers,
  addDatasetUsers,
  deleteDocUser,
  getChatHistoryData,
  getAllChatHistoryData,
  getRadioDataSets,
  deleteChatHistory,
  editChatHistory,
  getChatHistoryConversationData,
  getChatHistoryByFiltering,
  getQnaChatbotData,
  addChatHistoryData,
  saveChatHistoryConversation,
  getApprovedDataSet,
  datasetRequestAccess,
  getOthersDataSetList,
  getDocumentSummarizationData,
  downloadPdfUrlChat,
  getAllUsersList,
  addUserDataB2c,
  deleteB2cUser,
  getUserData,
  getGroupsData,
  createGroupData,
  updateGroupData,
  deleteGroupData,
  getGroupUsersData,
  addUsersToGroupData,
  removeUserFromGroupData,
  getAllDatasetRequestList,
  getAllDatasetUsersRequestList,
  approveDatasetRequestAccess,
  denyDatasetRequestAccess,
  chatFeedbackService,
  getFeedbackSugestion,
  getChatLikesCount,
  getChatLikesStatus,
  trainDocumentRequest,
  UpdateUserDataB2c,
  summarizationPdfUrl,
  editDatasetApi,
  getDataSetParameters,
  updatePromptAPI,
  createPromptAPI,
  deletePrompt,
  createDocSettingsAPI,
  fetchDocSettingsAPI,
  updateDocSettingsAPI,
  deleteParameter,
  addEngagementAPI,
  getEngagementAPI,
  saveServiceNowIntegrationAPI,
  getServiceNowIntegrationAPI,
  deleteServiceNowIntegrationAPI,
  sendEmailSupportAPI,
  deleteEmailSupportAPI,
  getEmailSupportAPI,
  registerHumanAgent,
  updateHumanAgentStatus,
  getHumanAgentStatus,
  updateHumanAgentQna,
  getHumanAgentQna,
  validateHumanAgent,
  saveHumanAgentEmail,
  getHumanAgentEmail,
  deleteHumanAgentEmail,
  fetchAssistantParametersAPI,
  saveAssistantParametersAPI,
  updateAssistantParametersAPI,
  deleteAssistantSettingsAPI,
  fetchCombinedDataAPI,
  validateExternalUUID, 
  getExternalDatasetAPI,
  saveTokenUsage,
  getTokenUsageStats,
  getTokenUsageSummary,
  getTokenUsageDaily,
  getTokenUsageByModel,
  getTokenUsageByUser,
  getTokenUsageByOrg
} from "../apis";
import { createQuickChatDataset } from "../services/quickChatService";


// Quick Chat Actions
export const CREATE_QUICK_CHAT_REQUEST = "CREATE_QUICK_CHAT_REQUEST";
export const CREATE_QUICK_CHAT_SUCCESS = "CREATE_QUICK_CHAT_SUCCESS";
export const CREATE_QUICK_CHAT_FAILURE = "CREATE_QUICK_CHAT_FAILURE";

export const FETCH_EXTERNAL_DATASET_REQUEST = "FETCH_EXTERNAL_DATASET_REQUEST";
export const FETCH_EXTERNAL_DATASET_SUCCESS = "FETCH_EXTERNAL_DATASET_SUCCESS";
export const FETCH_EXTERNAL_DATASET_FAILURE = "FETCH_EXTERNAL_DATASET_FAILURE";

export const FETCH_INNFERRE_TOKEN_REQUEST = "FETCH_INNFERRE_TOKEN_REQUEST";
export const FETCH_INNFERRE_TOKEN_SUCCESS = "FETCH_INNFERRE_TOKEN_SUCCESS";
export const FETCH_INNFERRE_TOKEN_FAILURE = "FETCH_INNFERRE_TOKEN_FAILURE";

export const FETCH_ASSISTANT_PARAMETERS_REQUEST = "FETCH_ASSISTANT_PARAMETERS_REQUEST";
export const FETCH_ASSISTANT_PARAMETERS_SUCCESS = "FETCH_ASSISTANT_PARAMETERS_SUCCESS";
export const FETCH_ASSISTANT_PARAMETERS_FAILURE = "FETCH_ASSISTANT_PARAMETERS_FAILURE";

export const SAVE_ASSISTANT_PARAMETERS_REQUEST =
  "SAVE_ASSISTANT_PARAMETERS_REQUEST";
export const SAVE_ASSISTANT_PARAMETERS_SUCCESS =
  "SAVE_ASSISTANT_PARAMETERS_SUCCESS";
export const SAVE_ASSISTANT_PARAMETERS_FAILURE =
  "SAVE_ASSISTANT_PARAMETERS_FAILURE";

export const DELETE_ASSISTANT_SETTINGS_REQUEST =
  "DELETE_ASSISTANT_SETTINGS_REQUEST";
export const DELETE_ASSISTANT_SETTINGS_SUCCESS =
  "DELETE_ASSISTANT_SETTINGS_SUCCESS";
export const DELETE_ASSISTANT_SETTINGS_FAILURE =
  "DELETE_ASSISTANT_SETTINGS_FAILURE";

export const UPDATE_ASSISTANT_PARAMETERS_REQUEST =
  "UPDATE_ASSISTANT_PARAMETERS_REQUEST";
export const UPDATE_ASSISTANT_PARAMETERS_SUCCESS =
  "UPDATE_ASSISTANT_PARAMETERS_SUCCESS";
export const UPDATE_ASSISTANT_PARAMETERS_FAILURE =
  "UPDATE_ASSISTANT_PARAMETERS_FAILURE";

export const EMAIL_SUPPORT_REQUEST = "EMAIL_SUPPORT_REQUEST";
export const EMAIL_SUPPORT_SUCCESS = "EMAIL_SUPPORT_SUCCESS";
export const EMAIL_SUPPORT_FAILURE = "EMAIL_SUPPORT_FAILURE";
export const DELETE_EMAIL_SUPPORT_REQUEST = "DELETE_EMAIL_SUPPORT_REQUEST";
export const DELETE_EMAIL_SUPPORT_SUCCESS = "DELETE_EMAIL_SUPPORT_SUCCESS";
export const DELETE_EMAIL_SUPPORT_FAILURE = "DELETE_EMAIL_SUPPORT_FAILURE";
export const GET_EMAIL_SUPPORT_REQUEST = "GET_EMAIL_SUPPORT_REQUEST";
export const GET_EMAIL_SUPPORT_SUCCESS = "GET_EMAIL_SUPPORT_SUCCESS";
export const GET_EMAIL_SUPPORT_FAILURE = "GET_EMAIL_SUPPORT_FAILURE";

export const SAVE_INTEGRATION_REQUEST = "SAVE_INTEGRATION_REQUEST";
export const SAVE_INTEGRATION_SUCCESS = "SAVE_INTEGRATION_SUCCESS";
export const SAVE_INTEGRATION_FAILURE = "SAVE_INTEGRATION_FAILURE";

export const FETCH_SERVICE_NOW_INTEGRATION_REQUEST =
  "FETCH_SERVICE_NOW_INTEGRATION_REQUEST";
export const FETCH_SERVICE_NOW_INTEGRATION_SUCCESS =
  "FETCH_SERVICE_NOW_INTEGRATION_SUCCESS";
export const FETCH_SERVICE_NOW_INTEGRATION_FAILURE =
  "FETCH_SERVICE_NOW_INTEGRATION_FAILURE";

export const DELETE_SERVICE_NOW_INTEGRATION_REQUEST =
  "DELETE_SERVICE_NOW_INTEGRATION_REQUEST";
export const DELETE_SERVICE_NOW_INTEGRATION_SUCCESS =
  "DELETE_SERVICE_NOW_INTEGRATION_SUCCESS";
export const DELETE_SERVICE_NOW_INTEGRATION_FAILURE =
  "DELETE_SERVICE_NOW_INTEGRATION_FAILURE";

export const FETCH_COMBINED_DATA_REQUEST = "FETCH_COMBINED_DATA_REQUEST";
export const FETCH_COMBINED_DATA_SUCCESS = "FETCH_COMBINED_DATA_SUCCESS";
export const FETCH_COMBINED_DATA_FAILURE = "FETCH_COMBINED_DATA_FAILURE";

export const getEmailSupport = (orgKey) => async (dispatch) => {
  dispatch({ type: GET_EMAIL_SUPPORT_REQUEST });
  try {
    const response = await getEmailSupportAPI(orgKey);
    dispatch({
      type: GET_EMAIL_SUPPORT_SUCCESS,
      payload: response.data,
    });
    return response; // so that caller can use then/catch
  } catch (error) {
    dispatch({
      type: GET_EMAIL_SUPPORT_FAILURE,
      payload: error,
    });
    throw error;
  }
};

export const deleteEmailSupport = (toEmail) => async (dispatch) => {
  dispatch({ type: DELETE_EMAIL_SUPPORT_REQUEST });
  try {
    const response = await deleteEmailSupportAPI(toEmail);
    dispatch({
      type: DELETE_EMAIL_SUPPORT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: DELETE_EMAIL_SUPPORT_FAILURE,
      payload: error,
    });
  }
};

//human-agent
export const CREATE_AGENT_REQUEST = "CREATE_AGENT_REQUEST";
export const CREATE_AGENT_SUCCESS = "CREATE_AGENT_SUCCESS";
export const CREATE_AGENT_FAILURE = "CREATE_AGENT_FAILURE";

export const UPDATE_AGENT_STATUS_REQUEST = "UPDATE_AGENT_STATUS_REQUEST";
export const UPDATE_AGENT_STATUS_SUCCESS = "UPDATE_AGENT_STATUS_SUCCESS";
export const UPDATE_AGENT_STATUS_FAILURE = "UPDATE_AGENT_STATUS_FAILURE";

export const GET_AGENT_STATUS_REQUEST = "GET_AGENT_STATUS_REQUEST";
export const GET_AGENT_STATUS_SUCCESS = "GET_AGENT_STATUS_SUCCESS";
export const GET_AGENT_STATUS_FAILURE = "GET_AGENT_STATUS_FAILURE";

export const CREATE_QNA_REQUEST = "CREATE_QNA_REQUEST";
export const CREATE_QNA_SUCCESS = "CREATE_QNA_SUCCESS";
export const CREATE_QNA_FAILURE = "CREATE_QNA_FAILURE";

export const GET_HUMAN_AGENT_QNA_REQUEST = "GET_HUMAN_AGENT_QNA_REQUEST";
export const GET_HUMAN_AGENT_QNA_SUCCESS = "GET_HUMAN_AGENT_QNA_SUCCESS";
export const GET_HUMAN_AGENT_QNA_FAILURE = "GET_HUMAN_AGENT_QNA_FAILURE";

export const VALIDATE_AGENT_REQUEST = "VALIDATE_AGENT_REQUEST";
export const VALIDATE_AGENT_SUCCESS = "VALIDATE_AGENT_SUCCESS";
export const VALIDATE_AGENT_FAILURE = "VALIDATE_AGENT_FAILURE";

export const SAVE_AGENT_EMAIL_REQUEST = "SAVE_AGENT_EMAIL_REQUEST";
export const SAVE_AGENT_EMAIL_SUCCESS = "SAVE_AGENT_EMAIL_SUCCESS";
export const SAVE_AGENT_EMAIL_FAILURE = "SAVE_AGENT_EMAIL_FAILURE";

export const GET_AGENT_EMAIL_REQUEST = "GET_AGENT_EMAIL_REQUEST";
export const GET_AGENT_EMAIL_SUCCESS = "GET_AGENT_EMAIL_SUCCESS";
export const GET_AGENT_EMAIL_FAILURE = "GET_AGENT_EMAIL_FAILURE";

export const DELETE_AGENT_EMAIL_REQUEST = "DELETE_AGENT_EMAIL_REQUEST";
export const DELETE_AGENT_EMAIL_SUCCESS = "DELETE_AGENT_EMAIL_SUCCESS";
export const DELETE_AGENT_EMAIL_FAILURE = "DELETE_AGENT_EMAIL_FAILURE";

export const CreateAgentRequest = () => ({
  type: CREATE_AGENT_REQUEST,
});

export const CreateAgentSuccess = (response) => ({
  type: CREATE_AGENT_SUCCESS,
  payload: response,
});

export const CreateAgentFailure = (error) => ({
  type: CREATE_AGENT_FAILURE,
  payload: error,
});

export const UpdateAgentStatusRequest = () => ({
  type: UPDATE_AGENT_STATUS_REQUEST,
});

export const UpdateAgentStatusSuccess = (response) => ({
  type: UPDATE_AGENT_STATUS_SUCCESS,
  payload: response,
});

export const UpdateAgentStatusFailure = (error) => ({
  type: UPDATE_AGENT_STATUS_FAILURE,
  payload: error,
});

export const getAgentStatusRequest = () => ({
  type: GET_AGENT_STATUS_REQUEST,
});

export const getAgentStatusSuccess = (response) => ({
  type: GET_AGENT_STATUS_SUCCESS,
  payload: response,
});

export const getAgentStatusFailure = (error) => ({
  type: GET_AGENT_STATUS_FAILURE,
  payload: error,
});

export const createQnaRequest = () => ({
  type: CREATE_QNA_REQUEST,
});

export const createQnaSuccess = (response) => ({
  type: CREATE_QNA_SUCCESS,
  payload: response,
});

export const createQnaFailure = (error) => ({
  type: CREATE_QNA_FAILURE,
  payload: error,
});

export const getHumanAgentQnaRequest = () => ({
  type: GET_HUMAN_AGENT_QNA_REQUEST,
});

export const getHumanAgentQnaSuccess = (response) => ({
  type: GET_HUMAN_AGENT_QNA_SUCCESS,
  payload: response,
});

export const getHumanAgentQnaFailure = (error) => ({
  type: GET_HUMAN_AGENT_QNA_FAILURE,
  payload: error,
});

export const validateAgentRequest = () => ({
  type: VALIDATE_AGENT_REQUEST,
});

export const validateAgentSuccess = (response) => ({
  type: VALIDATE_AGENT_SUCCESS,
  payload: response,
});

export const validateAgentFailure = (error) => ({
  type: VALIDATE_AGENT_FAILURE,
  payload: error,
});

export const saveAgentEmailRequest = () => ({
  type: SAVE_AGENT_EMAIL_REQUEST,
});

export const saveAgentEmailSuccess = (response) => ({
  type: SAVE_AGENT_EMAIL_SUCCESS,
  payload: response,
});

export const saveAgentEmailFailure = (error) => ({
  type: SAVE_AGENT_EMAIL_FAILURE,
  payload: error,
});

export const getAgentEmailRequest = () => ({
  type: GET_AGENT_EMAIL_REQUEST,
});

export const getAgentEmailSuccess = (response) => ({
  type: GET_AGENT_EMAIL_SUCCESS,
  payload: response,
});

export const getAgentEmailFailure = (error) => ({
  type: GET_AGENT_EMAIL_FAILURE,
  payload: error,
});

export const deleteAgentEmailRequest = () => ({
  type: DELETE_AGENT_EMAIL_REQUEST,
});

export const deleteAgentEmailSuccess = (response) => ({
  type: DELETE_AGENT_EMAIL_SUCCESS,
  payload: response,
});

export const deleteAgentEmailFailure = (error) => ({
  type: DELETE_AGENT_EMAIL_FAILURE,
  payload: error,
});

export const RESET_USER_QUESTION = "RESET_USER_QUESTION";
export const RESET_AGENT_RESPONSE = "RESET_AGENT_RESPONSE";

export const resetUserQuestion = () => ({
  type: RESET_USER_QUESTION,
});

export const resetAgentResponse = () => ({
  type: RESET_AGENT_RESPONSE,
});

export const RESET_AGENT_STATUS = "RESET_AGENT_STATUS";
export const resetAgentStatus = () => ({
  type: RESET_AGENT_STATUS,
});

export const RESET_QUESTION = "RESET_QUESTION";
export const RESET_ANSWER = "RESET_ANSWER";

export const resetQuestion = () => ({
  type: RESET_QUESTION,
});

export const resetAnswer = () => ({
  type: RESET_ANSWER,
});

export const deleteServiceNowIntegration = (datasetId) => async (dispatch) => {
  dispatch({ type: DELETE_SERVICE_NOW_INTEGRATION_REQUEST });
  try {
    const response = await deleteServiceNowIntegrationAPI(datasetId);
    dispatch({
      type: DELETE_SERVICE_NOW_INTEGRATION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: DELETE_SERVICE_NOW_INTEGRATION_FAILURE,
      payload: error,
    });
  }
};

export const sendEmailSupport = (payload) => async (dispatch) => {
  dispatch({ type: EMAIL_SUPPORT_REQUEST });
  try {
    const response = await sendEmailSupportAPI(payload);
    dispatch({
      type: EMAIL_SUPPORT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: EMAIL_SUPPORT_FAILURE,
      payload: error,
    });
  }
};

export const fetchServiceNowIntegration = (datasetId) => async (dispatch) => {
  dispatch({ type: FETCH_SERVICE_NOW_INTEGRATION_REQUEST });
  try {
    const response = await getServiceNowIntegrationAPI(datasetId);
    dispatch({
      type: FETCH_SERVICE_NOW_INTEGRATION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SERVICE_NOW_INTEGRATION_FAILURE,
      payload: error,
    });
  }
};

export const ADD_ENGAGEMENT_REQUEST = "ADD_ENGAGEMENT_REQUEST";
export const ADD_ENGAGEMENT_SUCCESS = "ADD_ENGAGEMENT_SUCCESS";
export const ADD_ENGAGEMENT_FAILURE = "ADD_ENGAGEMENT_FAILURE";

// Action Types
export const FETCH_ENGAGEMENT_REQUEST = "FETCH_ENGAGEMENT_REQUEST";
export const FETCH_ENGAGEMENT_SUCCESS = "FETCH_ENGAGEMENT_SUCCESS";
export const FETCH_ENGAGEMENT_FAILURE = "FETCH_ENGAGEMENT_FAILURE";

export const DELETE_PARAMETER_REQUEST = "DELETE_PARAMETER_REQUEST";
export const DELETE_PARAMETER_SUCCESS = "DELETE_PARAMETER_SUCCESS";
export const DELETE_PARAMETER_FAILURE = "DELETE_PARAMETER_FAILURE";

// Add new action types for deleting prompt, parameter, and dataset
export const DELETE_PROMPT_PARAMETER_DATASET_REQUEST =
  "DELETE_PROMPT_PARAMETER_DATASET_REQUEST";
export const DELETE_PROMPT_PARAMETER_DATASET_SUCCESS =
  "DELETE_PROMPT_PARAMETER_DATASET_SUCCESS";
export const DELETE_PROMPT_PARAMETER_DATASET_FAILURE =
  "DELETE_PROMPT_PARAMETER_DATASET_FAILURE";

export const CREATE_DOC_SETTINGS_REQUEST = "CREATE_DOC_SETTINGS_REQUEST";
export const CREATE_DOC_SETTINGS_SUCCESS = "CREATE_DOC_SETTINGS_SUCCESS";
export const CREATE_DOC_SETTINGS_FAILURE = "CREATE_DOC_SETTINGS_FAILURE";
// Action Types
export const FETCH_DOC_SETTINGS_REQUEST = "FETCH_DOC_SETTINGS_REQUEST";
export const FETCH_DOC_SETTINGS_SUCCESS = "FETCH_DOC_SETTINGS_SUCCESS";
export const FETCH_DOC_SETTINGS_FAILURE = "FETCH_DOC_SETTINGS_FAILURE";
export const UPDATE_DOC_SETTINGS_REQUEST = "UPDATE_DOC_SETTINGS_REQUEST";
export const UPDATE_DOC_SETTINGS_SUCCESS = "UPDATE_DOC_SETTINGS_SUCCESS";
export const UPDATE_DOC_SETTINGS_FAILURE = "UPDATE_DOC_SETTINGS_FAILURE";

export const REQUEST = "REQUEST";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const VIEWREQUEST = "VIEWREQUEST";
export const VIEWSUCCESS = "VIEWSUCCESS";
export const VIEWFAILURE = "VIEWFAILURE";
export const DELETEREQUEST = "DELETEREQUEST";
export const DELETESUCCESS = "DELETESUCCESS";
export const DELETEFAILURE = "DELETEFAILURE";

// Add new action types for deleting both prompt and dataset
export const DELETE_PROMPT_AND_DATASET_REQUEST =
  "DELETE_PROMPT_AND_DATASET_REQUEST";
export const DELETE_PROMPT_AND_DATASET_SUCCESS =
  "DELETE_PROMPT_AND_DATASET_SUCCESS";
export const DELETE_PROMPT_AND_DATASET_FAILURE =
  "DELETE_PROMPT_AND_DATASET_FAILURE";

//add dataset
export const ADD_REQUEST = "ADD_REQUEST";
export const ADD_SUCCESS = "ADD_SUCCESS";
export const ADD_FAILURE = "ADD_FAILURE";

//list dataset
export const LIST_REQUEST = "LIST_REQUEST";
export const LIST_SUCCESS = "LIST_SUCCESS";
export const LIST_FAILURE = "LIST_FAILURE";

//delete dataset
export const DEL_REQUEST = "DEL_REQUEST";
export const DEL_SUCCESS = "DEL_SUCCESS";
export const DEL_FAILURE = "DEL_FAILURE";

export const DOC_LIST_REQUEST = "DOC_LIST_REQUEST";
export const DOC_LIST_SUCCESS = "DOC_LIST_SUCCESS";
export const DOC_LIST_FAILURE = "DOC_LIST_FAILURE";

export const DOC_USER_LIST_REQUEST = "DOC_USER_LIST_REQUEST";
export const DOC_USER_LIST_SUCCESS = "DOC_USER_LIST_SUCCESS";
export const DOC_USER_LIST_FAILURE = "DOC_USER_LIST_FAILURE";

export const DATASET_USER_LIST_REQUEST = "DATASET_USER_LIST_REQUEST";
export const DATASET_USER_LIST_SUCCESS = "DATASET_USER_LIST_SUCCESS";
export const DATASET_USER_LIST_FAILURE = "DATASET_USER_LIST_FAILURE";

export const DATASET_USER_ADD_REQUEST = "DATASET_USER_ADD_REQUEST";
export const DATASET_USER_ADD_SUCCESS = "DATASET_USER_ADD_SUCCESS";
export const DATASET_USER_ADD_FAILURE = "DATASET_USER_ADD_FAILURE";

export const DATASET_USER_DELETE_REQUEST = "DATASET_USER_DELETE_REQUEST";
export const DATASET_USER_DELETE_SUCCESS = "DATASET_USER_DELETE_SUCCESS";
export const DATASET_USER_DELETE_FAILURE = "DATASET_USER_DELETE_FAILURE";

//list radio dataset
export const LIST_CHAT_HISTORY_REQUEST = "LIST_CHAT_HISTORY_REQUEST";
export const LIST_CHAT_HISTORY_SUCCESS = "LIST_CHAT_HISTORY_SUCCESS";
export const LIST_CHAT_HISTORY_FAILURE = "LIST_CHAT_HISTORY_FAILURE";
export const LIST_CHAT_HISTORY_APPEND = "LIST_CHAT_HISTORY_APPEND";

// All-chat-history cache (used by dashboards)
export const ALL_CHAT_HISTORY_REQUEST = "ALL_CHAT_HISTORY_REQUEST";
export const ALL_CHAT_HISTORY_SUCCESS = "ALL_CHAT_HISTORY_SUCCESS";
export const ALL_CHAT_HISTORY_FAILURE = "ALL_CHAT_HISTORY_FAILURE";
export const ALL_CHAT_HISTORY_INVALIDATE = "ALL_CHAT_HISTORY_INVALIDATE";

export const LIST_RADIO_REQUEST = "LIST_RADIO_REQUEST";
export const LIST_RADIO_SUCCESS = "LIST_RADIO_SUCCESS";
export const LIST_RADIO_FAILURE = "LIST_RADIO_FAILURE";

export const DOCUMENT_SUMMARIZATION_REQUEST = "DOCUMENT_SUMMARIZATION_REQUEST";
export const DOCUMENT_SUMMARIZATION_SUCCESS = "DOCUMENT_SUMMARIZATION_SUCCESS";
export const DOCUMENT_SUMMARIZATION_FAILURE = "DOCUMENT_SUMMARIZATION_FAILURE";

// src/actions/actionTypes.js
export const CREATE_PROMPT_REQUEST = "CREATE_PROMPT_REQUEST";
export const CREATE_PROMPT_SUCCESS = "CREATE_PROMPT_SUCCESS";
export const CREATE_PROMPT_FAILURE = "CREATE_PROMPT_FAILURE";

export const UPDATE_PROMPT_REQUEST = "UPDATE_PROMPT_REQUEST";
export const UPDATE_PROMPT_SUCCESS = "UPDATE_PROMPT_SUCCESS";
export const UPDATE_PROMPT_FAILURE = "UPDATE_PROMPT_FAILURE";

export const CHAT_HISTORY_CONVERSATION_REQUEST =
  "CHAT_HISTORY_CONVERSATION_REQUEST";
export const CHAT_HISTORY_CONVERSATION_SUCCESS =
  "CHAT_HISTORY_CONVERSATION_SUCCESS";
export const CHAT_HISTORY_CONVERSATION_FAILURE =
  "CHAT_HISTORY_CONVERSATION_FAILURE";
export const CHAT_HISTORY_CONVERSATION_RESET =
  "CHAT_HISTORY_CONVERSATION_RESET";

//delete chathistory
export const DEL_CHAT_HISTORY_REQUEST = "DEL_CHAT_HISTORY_REQUEST";
export const DEL_CHAT_HISTORY_SUCCESS = "DEL_CHAT_HISTORY_SUCCESS";
export const DEL_CHAT_HISTORY_FAILURE = "DEL_CHAT_HISTORY_FAILURE";

//edit chathistory
export const EDIT_CHAT_HISTORY_REQUEST = "EDIT_CHAT_HISTORY_REQUEST";
export const EDIT_CHAT_HISTORY_SUCCESS = "DEL_CHAT_HISTORY_SUCCESS";
export const EDIT_CHAT_HISTORY_FAILURE = "DEL_CHAT_HISTORY_FAILURE";

export const CHAT_HISTORY_FILTER_REQUEST = "CHAT_HISTORY_FILTER_REQUEST";
export const CHAT_HISTORY_FILTER_SUCCESS = "CHAT_HISTORY_FILTER_SUCCESS";
export const CHAT_HISTORY_FILTER_FAILURE = "CHAT_HISTORY_FILTER_FAILURE";
export const CHAT_HISTORY_FILTER_APPEND = "CHAT_HISTORY_FILTER_APPEND";
export const QNA_CHAT_REQUEST = "QNA_CHAT_REQUEST";
export const QNA_CHAT_SUCCESS = "QNA_CHAT_SUCCESS";
export const QNA_CHAT_FAILURE = "QNA_CHAT_FAILURE";

export const CREATE_CHAT_REQUEST = "CREATE_CHAT_REQUEST";
export const CREATE_CHAT_SUCCESS = "CREATE_CHAT_SUCCESS";
export const CREATE_CHAT_FAILURE = "CREATE_CHAT_FAILURE";

export const SUCCESS_PDFS_REQUEST = "SUCCESS_PDFS_REQUEST";
export const SUCCESS_PDFS_SUCCESS = "SUCCESS_PDFS_SUCCESS";
export const SUCCESS_PDFS_FAILURE = "SUCCESS_PDFS_FAILURE";

export const SUCCESS_CONVERSATION_REQUEST = "SUCCESS_CONVERSATION_REQUEST";
export const SUCCESS_CONVERSATION_SUCCESS = "SUCCESS_CONVERSATION_SUCCESS";
export const SUCCESS_CONVERSATION_FAILURE = "SUCCESS_CONVERSATION_FAILURE";

export const DATASET_ACCESS_REQUEST = "REQUEST";
export const DATASET_ACCESS_SUCCESS = "SUCCESS";
export const DATASET_ACCESS_FAILURE = "FAILURE";

export const DATASET_APPROVED_REQUEST = "REQUEST";
export const DATASET_APPROVED_SUCCESS = "SUCCESS";
export const DATASET_APPROVED_FAILURE = "FAILURE";

export const getParametersRequest = () => ({
  type: GET_PARAMETERS_REQUEST,
});

export const getParametersSuccess = (response) => ({
  type: GET_PARAMETERS_SUCCESS,
  payload: response,
});

export const getParametersFailure = (error) => ({
  type: GET_PARAMETERS_FAILURE,
  payload: error,
});

export const fetchDataSetParameters = (datasetId, history = false) => {
  return async (dispatch) => {
    dispatch(getParametersRequest());
    try {
      const response = await getDataSetParameters(datasetId, history); // Call the API
      dispatch(getParametersSuccess(response.data));
    } catch (error) {
      dispatch(getParametersFailure(error));
    }
  };
};

export const saveServiceNowIntegration = (payload) => async (dispatch) => {
  dispatch({ type: SAVE_INTEGRATION_REQUEST });
  try {
    const response = await saveServiceNowIntegrationAPI(payload);
    // If API call is successful:
    dispatch({ type: SAVE_INTEGRATION_SUCCESS, payload: response.data });
  } catch (error) {
    // If API call fails:
    dispatch({ type: SAVE_INTEGRATION_FAILURE, payload: error });
  }
};

export const DOWNLOAD_PDF_URL_REQUEST = "DOWNLOAD_PDF_URL_REQUEST";
export const DOWNLOAD_PDF_URL_SUCCESS = "DOWNLOAD_PDF_URL_SUCCESS";
export const DOWNLOAD_PDF_URL_FAILURE = "DOWNLOAD_PDF_URL_FAILURE";

export const USERS_LIST_REQUEST = "USERS_LIST_REQUEST";
export const USERS_LIST_SUCCESS = "USERS_LIST_SUCCESS";
export const USERS_LIST_FAILURE = "USERS_LIST_FAILURE";

export const ADD_USER_REQUEST = "ADD_USER_REQUEST";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_FAILURE = "ADD_USER_FAILURE";

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";

export const DATASET_REQUEST_LIST = "DATASET_REQUEST_LIST";
export const DATASET_REQUEST_LIST_SUCCESS = "DATASET_REQUEST_LIST_SUCCESS";
export const DATASET_REQUEST_LIST_FAILURE = "DATASET_REQUEST_LIST_FAILURE";

export const DATASET_USER_REQUEST_LIST = "DATASET_USER_REQUEST_LIST";
export const DATASET_USER_REQUEST_LIST_SUCCESS =
  "DATASET_USER_REQUEST_LIST_SUCCESS";
export const DATASET_USER_REQUEST_LIST_FAILURE =
  "DATASET_USER_REQUEST_LIST_FAILURE";

export const REQUEST_APPROVE_DATASET_LIST = "REQUEST_APPROVE_DATASET_LIST";
export const REQUEST_APPROVE_DATASET_LIST_SUCCESS =
  "REQUEST_APPROVE_DATASET_LIST_SUCCESS";
export const REQUEST_APPROVE_DATASET_LIST_FAILURE =
  "REQUEST_APPROVE_DATASET_LIST_FAILURE";

export const REQUEST_DENY_DATASET_LIST = "REQUEST_DENY_DATASET_LIST";
export const REQUEST_DENY_DATASET_LIST_SUCCESS =
  "REQUEST_DENY_DATASET_LIST_SUCCESS";
export const REQUEST_DENY_DATASET_LIST_FAILURE =
  "REQUEST_DENY_DATASET_LIST_FAILURE";

export const FEEDBACK_SERVICE_REQUEST = "FEEDBACK_SERVICE_REQUEST";
export const FEEDBACK_SERVICE_SUCCESS = "FEEDBACK_SERVICE_SUCCESS";
export const FEEDBACK_SERVICE_FAILURE = "FEEDBACK_SERVICE_FAILURE";

export const FEEDBACK_SUGGESTION_REQUEST = "FEEDBACK_SUGGESTION_REQUEST";
export const FEEDBACK_SUGGESTION_SUCCESS = "FEEDBACK_SUGGESTION_SUCCESS";
export const FEEDBACK_SUGGESTION_FAILURE = "FEEDBACK_SUGGESTION_FAILURE";

export const GETCHAT_COUNT_REQUEST = "GETCHAT_COUNT_REQUEST";
export const GETCHAT_COUNT_SUCCESS = "GETCHAT_COUNT_SUCCESS";
export const GETCHAT_COUNT_FAILURE = "GETCHAT_COUNT_FAILURE";

export const GETCHAT_STATUS_REQUEST = "GETCHAT_STATUS_REQUEST";
export const GETCHAT_STATUS_SUCCESS = "GETCHAT_STATUS_SUCCESS";
export const GETCHAT_STATUS_FAILURE = "GETCHAT_STATUS_FAILURE";
export const TRAIN_REQUEST = "TRAIN_REQUEST";
export const TRAIN_SUCCESS = "TRAIN_SUCCESS";
export const TRAIN_FAILURE = "TRAIN_FAILURE";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const SUMMARIZATION_DOC_URL_REQUEST = "SUMMARIZATION_DOC_URL_REQUEST";
export const SUMMARIZATION_DOC_URL_SUCCESS = "SUMMARIZATION_DOC_URL_SUCCESS";
export const SUMMARIZATION_DOC_URL_FAILURE = "SUMMARIZATION_DOC_URL_FAILURE";

//edit chathistory
export const EDIT_DATASET_REQUEST = "EDIT_DATASET_REQUEST";
export const EDIT_DATASET_SUCCESS = "EDIT_DATASET_SUCCESS";
export const EDIT_DATASET_FAILURE = "EDIT_DATASET_FAILURE";

export const DATASET_OTHERS_REQUEST = "REQUEST";
export const DATASET_OTHERS_SUCCESS = "SUCCESS";
export const DATASET_OTHERS_FAILURE = "FAILURE";

export const GET_PARAMETERS_REQUEST = "GET_PARAMETERS_REQUEST";
export const GET_PARAMETERS_SUCCESS = "GET_PARAMETERS_SUCCESS";
export const GET_PARAMETERS_FAILURE = "GET_PARAMETERS_FAILURE";

export const DELETE_PROMPT_REQUEST = "DELETE_PROMPT_REQUEST";
export const DELETE_PROMPT_SUCCESS = "DELETE_PROMPT_SUCCESS";
export const DELETE_PROMPT_FAILURE = "DELETE_PROMPT_FAILURE";

export const deletePromptAndDatasetAction = (datasetId) => async (dispatch) => {
  dispatch({ type: DELETE_PROMPT_AND_DATASET_REQUEST });
  try {
    await dispatch(deletePromptAction(datasetId));
    await dispatch(deleteDatasets(datasetId));
    dispatch({ type: DELETE_PROMPT_AND_DATASET_SUCCESS });
  } catch (error) {
    dispatch({
      type: DELETE_PROMPT_AND_DATASET_FAILURE,
      error: error.response ? error.response.data : "Unknown error",
    });
  }
};

// Add this function for deleting a prompt
export const deletePromptAction = (datasetId) => async (dispatch) => {
  dispatch({ type: DELETE_PROMPT_REQUEST });
  try {
    const response = await deletePrompt(datasetId);
    dispatch({ type: DELETE_PROMPT_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: DELETE_PROMPT_FAILURE,
      error: error.response ? error.response.data : "Unknown error",
    });
  }
};

export const apiRequest = () => ({
  type: REQUEST,
});

export const requestSuccess = (response) => ({
  type: SUCCESS,
  payload: response,
});

export const requestFailure = (error) => ({
  type: FAILURE,
  payload: error,
});

export const viewRequest = () => ({
  type: VIEWREQUEST,
});

export const requestViewSuccess = (response) => ({
  type: VIEWSUCCESS,
  payload: response,
});

export const requestViewFailure = (error) => ({
  type: VIEWFAILURE,
  payload: error,
});

export const deleteRequest = () => ({
  type: DELETEREQUEST,
});

export const deleteSuccess = (response) => ({
  type: DELETESUCCESS,
  payload: response,
});

export const deleteFailure = (error) => ({
  type: DELETEFAILURE,
  payload: error,
});

export const AddApiRequest = () => ({
  type: ADD_REQUEST,
});

export const AddRequestSuccess = (response) => ({
  type: ADD_SUCCESS,
  payload: response,
});

export const AddRequestFailure = (error) => ({
  type: ADD_FAILURE,
  payload: error,
});

export const ListApiRequest = () => ({
  type: LIST_REQUEST,
});

export const ListRequestSuccess = (response) => ({
  type: LIST_SUCCESS,
  payload: response,
});

export const ListRequestFailure = (error) => ({
  type: LIST_FAILURE,
  payload: error,
});

export const DelApiRequest = () => ({
  type: DEL_REQUEST,
});

export const DelRequestSuccess = (response) => ({
  type: DEL_SUCCESS,
  payload: response,
});

export const DelRequestFailure = (error) => ({
  type: DEL_FAILURE,
  payload: error,
});

export const getDocumentRequest = () => ({
  type: DOC_LIST_REQUEST,
});

export const getDocumentSuccess = (response) => ({
  type: DOC_LIST_SUCCESS,
  payload: response,
});

export const getDocumentFailure = (error) => ({
  type: DOC_LIST_FAILURE,
  payload: error,
});

export const AllDocumentUsersDataRequest = () => ({
  type: DOC_USER_LIST_REQUEST,
});

export const AllDocumentUsersDataSuccess = (response) => ({
  type: DOC_USER_LIST_SUCCESS,
  payload: response,
});

export const AllDocumentUsersDataFailure = (error) => ({
  type: DOC_USER_LIST_FAILURE,
  payload: error,
});

export const DatasetUsersDataRequest = () => ({
  type: DATASET_USER_LIST_REQUEST,
});

export const DatasetUsersDataSuccess = (response) => ({
  type: DATASET_USER_LIST_SUCCESS,
  payload: response,
});

export const DatasetUsersDataFailure = (error) => ({
  type: DATASET_USER_LIST_FAILURE,
  payload: error,
});

export const AddDatasetUsersDataRequest = () => ({
  type: DATASET_USER_ADD_REQUEST,
});

export const AddDatasetUsersDataSuccess = (response) => ({
  type: DATASET_USER_ADD_SUCCESS,
  payload: response,
});

export const AddDatasetUsersDataFailure = (error) => ({
  type: DATASET_USER_ADD_FAILURE,
  payload: error,
});

export const DeleteDocumentRequest = () => ({
  type: DATASET_USER_DELETE_REQUEST,
});

export const DeleteDocumentSuccess = (response) => ({
  type: DATASET_USER_DELETE_SUCCESS,
  payload: response,
});

export const DeleteDocumentFailure = (error) => ({
  type: DATASET_USER_DELETE_FAILURE,
  payload: error,
});

export const ListChatHistoryApiRequest = () => ({
  type: LIST_CHAT_HISTORY_REQUEST,
});

export const ListChatHistoryRequestSuccess = (response) => ({
  type: LIST_CHAT_HISTORY_SUCCESS,
  payload: response,
});

export const ListChatHistoryRequestFailure = (error) => ({
  type: LIST_CHAT_HISTORY_FAILURE,
});

export const ListChatHistoryAppend = (response) => ({
  type: LIST_CHAT_HISTORY_APPEND,
  payload: response,
});

// All-chat-history cache action creators
export const AllChatHistoryRequest = () => ({
  type: ALL_CHAT_HISTORY_REQUEST,
});

export const AllChatHistorySuccess = (data) => ({
  type: ALL_CHAT_HISTORY_SUCCESS,
  payload: data,
});

export const AllChatHistoryFailure = (error) => ({
  type: ALL_CHAT_HISTORY_FAILURE,
  payload: error,
});

export const AllChatHistoryInvalidate = () => ({
  type: ALL_CHAT_HISTORY_INVALIDATE,
});

export const ListRadioApiRequest = () => ({
  type: LIST_RADIO_REQUEST,
});

export const ListRadioRequestSuccess = (response) => ({
  type: LIST_RADIO_SUCCESS,
  payload: response,
});

export const ListRadioRequestFailure = (error) => ({
  type: LIST_RADIO_FAILURE,
  payload: error,
});

export const DeleteChatHistoryRequest = () => ({
  type: DEL_CHAT_HISTORY_REQUEST,
});

export const DeleteChatHistorySuccess = (response) => ({
  type: DEL_CHAT_HISTORY_SUCCESS,
  payload: response,
});

export const DeleteChatHistoryFailure = (error) => ({
  type: DEL_CHAT_HISTORY_FAILURE,
  payload: error,
});

export const EditChatHistoryRequest = () => ({
  type: EDIT_CHAT_HISTORY_REQUEST,
});

export const EditChatHistorySuccess = (response) => ({
  type: EDIT_CHAT_HISTORY_SUCCESS,
  payload: response,
});

export const EditChatHistoryFailure = (error) => ({
  type: EDIT_CHAT_HISTORY_FAILURE,
  payload: error,
});
export const HistoryConversationRequest = () => ({
  type: CHAT_HISTORY_CONVERSATION_REQUEST,
});
export const HistoryConversationSuccess = (response) => ({
  type: CHAT_HISTORY_CONVERSATION_SUCCESS,
  payload: response,
});

export const HistoryConversationFailure = (error) => ({
  type: CHAT_HISTORY_CONVERSATION_FAILURE,
  payload: error,
});

export const resetChatHistoryConversation = () => ({
  type: CHAT_HISTORY_CONVERSATION_RESET,
});

export const ChatHistoryFilterRequest = () => ({
  type: CHAT_HISTORY_FILTER_REQUEST,
});
export const ChatHistoryFilterSuccess = (response) => ({
  type: CHAT_HISTORY_FILTER_SUCCESS,
  payload: response,
});

export const ChatHistoryFilterFailure = (error) => ({
  type: CHAT_HISTORY_FILTER_FAILURE,
  payload: error,
});

export const ChatHistoryFilterAppend = (response) => ({
  type: CHAT_HISTORY_FILTER_APPEND,
  payload: response,
});
export const QnaChatbotRequest = () => ({
  type: QNA_CHAT_REQUEST,
});
export const QnaChatbotSuccess = (response) => ({
  type: QNA_CHAT_SUCCESS,
  payload: response,
});

export const QnaChatbotFailure = (error) => ({
  type: QNA_CHAT_FAILURE,
  payload: error,
});

export const createChatHistoryDataRequest = () => ({
  type: CREATE_CHAT_REQUEST,
});
export const createChatHistoryDataSuccess = (response) => ({
  type: CREATE_CHAT_SUCCESS,
  payload: response,
});
export const createChatHistoryDataFailure = (error) => ({
  type: CREATE_CHAT_FAILURE,
  payload: error,
});

export const addSuccessPDFsRequest = () => ({
  type: SUCCESS_PDFS_REQUEST,
});

export const addSuccessPDFsSuccess = (response) => ({
  type: SUCCESS_PDFS_SUCCESS,
  payload: response,
});

export const addSuccessPDFsFailure = (error) => ({
  type: SUCCESS_PDFS_FAILURE,
  payload: error,
});

export const saveRequestConversation = () => ({
  type: SUCCESS_CONVERSATION_REQUEST,
});
export const addSuccessConversation = (response) => ({
  type: SUCCESS_CONVERSATION_SUCCESS,
  payload: response,
});
export const addConversationFailure = (error) => ({
  type: SUCCESS_CONVERSATION_FAILURE,
  payload: error,
});

export const datasetAccessRequest = () => ({
  type: DATASET_ACCESS_REQUEST,
});

export const datasetAccessSuccess = (response) => ({
  type: DATASET_ACCESS_SUCCESS,
  payload: response,
});

export const datasetAccessFailure = (error) => ({
  type: DATASET_ACCESS_FAILURE,
  payload: error,
});

export const ListApprovedRequest = () => ({
  type: DATASET_APPROVED_REQUEST,
});

export const ListApprovedSuccess = (response) => ({
  type: DATASET_APPROVED_SUCCESS,
  payload: response,
});

export const ListApprovedFailure = (error) => ({
  type: DATASET_APPROVED_FAILURE,
  payload: error,
});

export const ListOthersRequest = () => ({
  type: DATASET_OTHERS_REQUEST,
});

export const ListOthersSuccess = (response) => ({
  type: DATASET_OTHERS_SUCCESS,
  payload: response,
});

export const ListOthersFailure = (error) => ({
  type: DATASET_OTHERS_FAILURE,
  payload: error,
});

export const DocumentSummarizationRequest = () => ({
  type: "DOCUMENT_SUMMARIZATION_REQUEST",
});

export const DocumentSummarizationSuccess = (response) => ({
  type: "DOCUMENT_SUMMARIZATION_SUCCESS",
  payload: response,
});

export const DocumentSummarizationFailure = (error) => ({
  type: "DOCUMENT_SUMMARIZATION_FAILURE",
  payload: error,
});

export const DownloadPdfUrlRequest = () => ({
  type: "DOWNLOAD_PDF_URL_REQUEST",
});

export const DownloadPdfUrlSuccess = (response) => ({
  type: "DOWNLOAD_PDF_URL_SUCCESS",
  payload: response,
});

export const getUserRequest = () => ({
  type: GET_USER_REQUEST,
});

export const getUserSuccess = (response) => ({
  type: GET_USER_SUCCESS,
  payload: response,
});

export const getUserFailure = (error) => ({
  type: GET_USER_FAILURE,
  payload: error,
});

export const UsersListRequest = () => ({
  type: USERS_LIST_REQUEST,
});

export const UsersListSuccess = (response) => ({
  type: USERS_LIST_SUCCESS,
  payload: response,
});

export const UsersListFailure = (error) => ({
  type: USERS_LIST_FAILURE,
  payload: error,
});

export const AddUserApiRequest = () => ({
  type: "ADD_USER_REQUEST",
});

export const AddUserRequestSuccess = (response) => ({
  type: "ADD_USER_SUCCESS",
  payload: response,
});

export const AdduserRequestFailure = (error) => ({
  type: "ADD_USER_FAILURE",
  payload: error,
});

export const DownloadPdfUrlFailure = (error) => ({
  type: "DOWNLOAD_PDF_URL_FAILURE",
  payload: error,
});

export const DeleteUserRequest = () => ({
  type: "DELETE_USER_REQUEST",
});

export const DeleteUserSuccess = (response) => ({
  type: "DELETE_USER_SUCCESS",
  payload: response,
});

export const DeleteUserFailure = (error) => ({
  type: "DELETE_USER_FAILURE",
  payload: error,
});

export const requestDatasetList = () => ({
  type: DATASET_REQUEST_LIST,
});

export const requestDatasetListSuccess = (response) => ({
  type: DATASET_REQUEST_LIST_SUCCESS,
  payload: response,
});

export const requestDatasetListFailure = (error) => ({
  type: DATASET_REQUEST_LIST_FAILURE,
  payload: error,
});

export const requestUserDatasetList = () => ({
  type: DATASET_USER_REQUEST_LIST,
});

export const requestUserDatasetListSuccess = (response) => ({
  type: DATASET_USER_REQUEST_LIST_SUCCESS,
  payload: response,
});

export const requestUserDatasetListFailure = (error) => ({
  type: DATASET_USER_REQUEST_LIST_FAILURE,
  payload: error,
});

export const requestDenyDatasetList = () => ({
  type: REQUEST_DENY_DATASET_LIST,
});

export const requestDenyDatasetListSuccess = (response) => ({
  type: REQUEST_DENY_DATASET_LIST_SUCCESS,
  payload: response,
});

export const requestDenyDatasetListFailure = (error) => ({
  type: REQUEST_DENY_DATASET_LIST_FAILURE,
  payload: error,
});

export const requestApproveDatasetList = () => ({
  type: REQUEST_APPROVE_DATASET_LIST,
});

export const requestApproveDatasetListSuccess = (response) => ({
  type: REQUEST_APPROVE_DATASET_LIST_SUCCESS,
  payload: response,
});

export const requestApproveDatasetListFailure = (error) => ({
  type: REQUEST_APPROVE_DATASET_LIST_FAILURE,
  payload: error,
});

export const FeedbackServiceApiRequest = () => ({
  type: FEEDBACK_SERVICE_REQUEST,
});

export const FeedbackServiceApiSuccess = (response) => ({
  type: FEEDBACK_SERVICE_SUCCESS,
  payload: response,
});

export const FeedbackServiceApiFailure = (error) => ({
  type: FEEDBACK_SERVICE_FAILURE,
  payload: error,
});

export const feedbackSuggestionRequest = () => ({
  type: FEEDBACK_SUGGESTION_REQUEST,
});

export const feedbackSuggestionSuccess = (response) => ({
  type: FEEDBACK_SUGGESTION_SUCCESS,
  payload: response,
});

export const feedbackSuggestionFailure = (error) => ({
  type: FEEDBACK_SUGGESTION_FAILURE,
  payload: error,
});

export const chatCountRequest = () => ({
  type: GETCHAT_COUNT_REQUEST,
});

export const chatCountSuccess = (response) => ({
  type: GETCHAT_COUNT_SUCCESS,
  payload: response,
});

export const chatCountFailure = (error) => ({
  type: GETCHAT_COUNT_FAILURE,
  payload: error,
});

export const chatStatusRequest = () => ({
  type: GETCHAT_STATUS_REQUEST,
});

export const chatStatusSuccess = (response) => ({
  type: GETCHAT_STATUS_SUCCESS,
  payload: response,
});

export const chatStatusFailure = (error) => ({
  type: GETCHAT_STATUS_FAILURE,
  payload: error,
});
export const apiTrainRequest = () => ({
  type: TRAIN_REQUEST,
});

export const requestTrainSuccess = (response) => ({
  type: "TRAIN_SUCCESS",
  payload: response,
});

export const requestTrainFailure = (error) => ({
  type: "TRAIN_FAILURE",
  payload: error,
});

export const UpdateUserApiRequest = () => ({
  type: "UPDATE_USER_REQUEST",
});

export const UpdateUserRequestSuccess = (response) => ({
  type: "UPDATE_USER_SUCCESS",
  payload: response,
});

export const UpdateUserRequestFailure = (error) => ({
  type: "UPDATE_USER_FAILURE",
  payload: error,
});

export const requestSummarizationDocUrl = () => ({
  type: SUMMARIZATION_DOC_URL_REQUEST,
});

export const successSummarizationDocUrl = (response) => ({
  type: SUMMARIZATION_DOC_URL_SUCCESS,
  payload: response,
});

export const failureSummarizationUrl = (error) => ({
  type: SUMMARIZATION_DOC_URL_FAILURE,
  payload: error,
});

export const EditDatasetRequest = () => ({
  type: EDIT_DATASET_REQUEST,
});

export const EditDatasetSuccess = (response) => ({
  type: EDIT_DATASET_SUCCESS,
  payload: response,
});

export const EditDatasetFailure = (error) => ({
  type: EDIT_DATASET_FAILURE,
  payload: error,
});

export const addDocuments = (payload, datasetId, docSettings) => {
  return async (dispatch) => {
    dispatch(apiRequest());
    try {
      const response = await addDocument(payload, datasetId, docSettings);
      dispatch(requestSuccess(response));
    } catch (error) {
      if (error.response && error.response.status === 400) {
        dispatch(requestFailure({ data: error.response.data, status: 400 }));
      } else {
        dispatch(
          requestFailure({
            data: "API error",
            status: error.response ? error.response.status : 500,
          })
        );
      }
    }
  };
};

export const getDocumentsDetails = (payload) => {
  return async (dispatch) => {
    dispatch(getDocumentRequest());
    try {
      const response = await getDocumentDetails(payload);
      dispatch(getDocumentSuccess(response));
    } catch (error) {
      dispatch(getDocumentFailure("API error"));
    }
  };
};

export const dltDocumentFile = (payload) => {
  return async (dispatch) => {
    dispatch(deleteRequest());
    try {
      const response = await deleteDocumentFile(payload);
      dispatch(deleteSuccess(response));
    } catch (error) {
      dispatch(deleteFailure("API error"));
    }
  };
};

export const viewDocumentFile = (datasetId, docId) => {
  return async (dispatch) => {
    dispatch(viewRequest());
    try {
      const response = await downloadDocumentFile(datasetId, docId);
      dispatch(requestViewSuccess(response));
    } catch (error) {
      dispatch(requestViewFailure("API error"));
    }
  };
};

export const addDataSet = (payload, isExternal = false) => {
  return async (dispatch) => {
    dispatch(AddApiRequest());
    try {
      // ✅ Inject the external flag
      const finalPayload = { 
        ...payload, 
        isExternalUser: isExternal 
      };

      const response = await addDataSets(finalPayload);
      dispatch(AddRequestSuccess(response));
    } catch (error) {
      if (error.response?.status === 400) {
        dispatch(AddRequestSuccess(error.response));
      } else {
        dispatch(AddRequestFailure("API error"));
      }
    }
  };
};


export const getDatasets = () => {
  return async (dispatch) => {
    dispatch(ListApiRequest());
    try {
      const response = await getDataSet();
      dispatch(ListRequestSuccess(response));
    } catch (error) {
      dispatch(ListRequestFailure("API error"));
    }
  };
};

export const deleteDatasets = (payload) => {
  return async (dispatch) => {
    dispatch(DelApiRequest());
    try {
      const response = await deleteDataSet(payload);
      dispatch(DelRequestSuccess(response));
    } catch (error) {
      dispatch(DelRequestFailure("API error"));
    }
  };
};

export const getAllDocumentUsersData = () => {
  return async (dispatch) => {
    dispatch(AllDocumentUsersDataRequest());
    try {
      const response = await allDocumentUsers();
      dispatch(AllDocumentUsersDataSuccess(response));
    } catch (error) {
      dispatch(AllDocumentUsersDataFailure("API error"));
    }
  };
};

export const getDatasetUsersData = (datasetId) => {
  return async (dispatch) => {
    dispatch(DatasetUsersDataRequest());
    try {
      const response = await allDatasetUsers(datasetId);
      dispatch(DatasetUsersDataSuccess(response));
    } catch (error) {
      dispatch(DatasetUsersDataFailure("API error"));
    }
  };
};

export const AddDocumentUsersData = (payload, datasetId) => {
  return async (dispatch) => {
    dispatch(AddDatasetUsersDataRequest());
    try {
      const response = await addDatasetUsers(payload, datasetId);
      dispatch(AddDatasetUsersDataSuccess(response));
    } catch (error) {
      dispatch(AddDatasetUsersDataFailure("API error"));
    }
  };
};

export const deleteDocumentUser = (datasetId, userID) => {
  return async (dispatch) => {
    dispatch(DeleteDocumentRequest());
    try {
      const response = await deleteDocUser(datasetId, userID);
      dispatch(DeleteDocumentSuccess(response));
    } catch (error) {
      dispatch(DeleteDocumentFailure("API error"));
    }
  };
};

export const getChatHistory = (page = 1, pageSize = 20, search = "") => {
  return async (dispatch) => {
    if (page === 1) {
      dispatch(ListChatHistoryApiRequest());
    }
    try {
      const response = await getChatHistoryData(page, pageSize, search);
      if (page === 1) {
        dispatch(ListChatHistoryRequestSuccess(response));
      } else {
        dispatch(ListChatHistoryAppend(response));
      }
    } catch (error) {
      dispatch(ListChatHistoryRequestFailure("API error"));
    }
  };
};

// Cached fetch of all chat history pages. Re-uses store cache if already fetched.
// Pass { force: true } to bypass cache.
let _allChatHistoryInFlight = null;
export const getAllChatHistoryCached = (options = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const cache = state.allChatHistoryRed || {};
    if (!options.force && cache.fetched) {
      return cache.data || [];
    }
    // If a fetch is already in flight, await the same promise so concurrent
    // callers receive the actual data instead of an empty array.
    if (!options.force && _allChatHistoryInFlight) {
      return _allChatHistoryInFlight;
    }
    dispatch(AllChatHistoryRequest());
    _allChatHistoryInFlight = (async () => {
      try {
        const data = await getAllChatHistoryData();
        dispatch(AllChatHistorySuccess(data));
        return data;
      } catch (error) {
        dispatch(AllChatHistoryFailure(error?.message || "API error"));
        return [];
      } finally {
        _allChatHistoryInFlight = null;
      }
    })();
    return _allChatHistoryInFlight;
  };
};

export const getRadioDataActionSet = () => {
  return async (dispatch) => {
    dispatch(ListRadioApiRequest());
    try {
      const response = await getRadioDataSets();
      dispatch(ListRadioRequestSuccess(response));
    } catch (error) {
      dispatch(ListRadioRequestFailure("API error"));
    }
  };
};

export const deleteChatHistoryData = (payload) => {
  return async (dispatch) => {
    dispatch(DeleteChatHistoryRequest());
    try {
      const response = await deleteChatHistory(payload);
      dispatch(DeleteChatHistorySuccess(response));
    } catch (error) {
      dispatch(DeleteChatHistoryFailure("API error"));
    }
  };
};

export const editChatHistoryData = (payload, id) => {
  return async (dispatch) => {
    dispatch(EditChatHistoryRequest());
    try {
      const response = await editChatHistory(payload, id);
      dispatch(EditChatHistorySuccess(response));
    } catch (error) {
      dispatch(EditChatHistoryFailure("API error"));
    }
  };
};

export const getChatHistoryConversation = (chatBotQueryParam) => {
  return async (dispatch) => {
    dispatch(HistoryConversationRequest());
    try {
      const response = await getChatHistoryConversationData(chatBotQueryParam);
      dispatch(HistoryConversationSuccess(response));
      return response; // Return the response data
    } catch (error) {
      console.error("API error:", error);
      dispatch(HistoryConversationFailure("API error"));
      return null; // Return null in case of error
    }
  };
};

export const getChatConversationForMiddleware = async (chatBotQueryParam) => {
  try {
    const response = await getChatHistoryConversationData(chatBotQueryParam);
    return response;
  } catch (error) {
    console.error("API error:", error);
  }
};

export const getChatHistoryByFilter = (queryString, page = 1, pageSize = 20, search = "") => {
  return async (dispatch) => {
    if (page === 1) {
      dispatch(ChatHistoryFilterRequest());
    }
    try {
      const response = await getChatHistoryByFiltering(queryString, page, pageSize, search);
      if (page === 1) {
        dispatch(ChatHistoryFilterSuccess(response));
      } else {
        dispatch(ChatHistoryFilterAppend(response));
      }
    } catch (error) {
      dispatch(ChatHistoryFilterFailure("API_Error"));
    }
  };
};

export const qnaChatbotSession = (payload, datasetId, chatID) => {
  return async (dispatch) => {
    dispatch(QnaChatbotRequest());
    try {
      const response = await getQnaChatbotData(payload, datasetId, chatID);
      dispatch(QnaChatbotSuccess(response));
    } catch (error) {
      dispatch(QnaChatbotFailure("API error"));
    }
  };
};

export const createChatHistoryData = (payload) => {
  return async (dispatch) => {
    dispatch(createChatHistoryDataRequest());
    try {
      const response = await addChatHistoryData(payload);
      dispatch(createChatHistoryDataSuccess(response));
    } catch (error) {
      dispatch(createChatHistoryDataFailure("API error"));
    }
  };
};

export const SaveHistoryConversation = (payload, chatBotQueryParam) => {
  return async (dispatch) => {
    dispatch(saveRequestConversation());
    try {
      const response = await saveChatHistoryConversation(
        payload,
        chatBotQueryParam
      );
      dispatch(addSuccessConversation(response));
      return response;
    } catch (error) {
      dispatch(addConversationFailure("API error"));
      throw error;
    }
  };
};

export const getApprovedDatasets = (payload) => {
  return async (dispatch) => {
    dispatch(ListApprovedRequest());
    try {
      const response = await getApprovedDataSet(payload);
      dispatch(ListApprovedSuccess(response));
    } catch (error) {
      dispatch(ListApprovedFailure("API error"));
    }
  };
};

export const getOthersDatasets = (payload) => {
  return async (dispatch) => {
    dispatch(ListOthersRequest());
    try {
      const response = await getOthersDataSetList(payload);
      dispatch(ListOthersSuccess(response));
    } catch (error) {
      dispatch(ListOthersFailure("API error"));
    }
  };
};

export const postDatasetRequestAccess = (payload) => {
  return async (dispatch) => {
    dispatch(datasetAccessRequest());
    try {
      const response = await datasetRequestAccess(payload);
      dispatch(datasetAccessSuccess(response));
    } catch (error) {
      if (error.response.status === 400) {
        dispatch(datasetAccessSuccess(error.response));
      }
      dispatch(datasetAccessFailure("API error:" + error));
    }
  };
};

export const getDocumantSummerization = (datasetId, documentName) => {
  return async (dispatch) => {
    dispatch(DocumentSummarizationRequest());
    try {
      const response = await getDocumentSummarizationData(
        datasetId,
        documentName
      );
      dispatch(DocumentSummarizationSuccess(response));
    } catch (error) {
      dispatch(DocumentSummarizationFailure("API error"));
    }
  };
};

export const getDownloadPdfUrl = (datasetId, documentName) => {
  return async (dispatch) => {
    dispatch(DownloadPdfUrlRequest());
    try {
      const response = await downloadPdfUrlChat(datasetId, documentName);
      dispatch(DownloadPdfUrlSuccess(response));
    } catch (error) {
      if (error.response.status === 404) {
        dispatch(DownloadPdfUrlSuccess(error.response));
      } else {
        dispatch(DownloadPdfUrlFailure("API error"));
      }
    }
  };
};

export const getUserDataB2C = (userId) => {
  return async (dispatch) => {
    dispatch(getUserRequest());
    try {
      const response = await getUserData(userId);
      dispatch(getUserSuccess(response));
    } catch (error) {
      dispatch(getUserFailure("API error"));
    }
  };
};

export const getUsersList = () => {
  return async (dispatch) => {
    dispatch(UsersListRequest());
    try {
      const response = await getAllUsersList();
      dispatch(UsersListSuccess(response));
    } catch (error) {
      dispatch(UsersListFailure("API error"));
    }
  };
};

export const addUserDataAPI = (payload) => {
  return async (dispatch) => {
    dispatch(AddUserApiRequest());
    try {
      const response = await addUserDataB2c(payload);
      dispatch(AddUserRequestSuccess(response));
    } catch (error) {
      if (error.response.status === 400) {
        dispatch(AddUserRequestSuccess(error.response));
      } else {
        dispatch(AdduserRequestFailure("API error"));
      }
    }
  };
};

export const deleteUserData = (userId) => {
  return async (dispatch) => {
    dispatch(DeleteUserRequest());
    try {
      const response = await deleteB2cUser(userId);
      dispatch(DeleteUserSuccess(response));
    } catch (error) {
      dispatch(DeleteUserFailure("API error"));
    }
  };
};

export const getDatasetRequestList = () => {
  return async (dispatch) => {
    dispatch(requestDatasetList());
    try {
      const response = await getAllDatasetRequestList();
      dispatch(requestDatasetListSuccess(response));
    } catch (error) {
      dispatch(requestDatasetListFailure("API error"));
    }
  };
};

export const getDatasetUsersRequestList = (userIdParam) => {
  return async (dispatch) => {
    dispatch(requestUserDatasetList());
    try {
      const response = await getAllDatasetUsersRequestList(userIdParam);
      dispatch(requestUserDatasetListSuccess(response));
    } catch (error) {
      dispatch(requestUserDatasetListFailure("API error"));
    }
  };
};

export const approveAllDatasetRequest = (userId, datasetIds) => {
  return async (dispatch) => {
    dispatch(requestApproveDatasetList());
    try {
      const response = await approveDatasetRequestAccess(userId, datasetIds);
      dispatch(requestApproveDatasetListSuccess(response));
    } catch (error) {
      if (error.response.status != 200) {
        dispatch(requestApproveDatasetListSuccess(error.response));
      }
      dispatch(requestApproveDatasetListFailure("API error"));
    }
  };
};

export const denyAllDatasetRequest = (userId, datasetIds) => {
  return async (dispatch) => {
    dispatch(requestDenyDatasetList());
    try {
      const response = await denyDatasetRequestAccess(userId, datasetIds);
      dispatch(requestDenyDatasetListSuccess(response));
    } catch (error) {
      if (error.response.status != 200) {
        dispatch(requestDenyDatasetListSuccess(error.response));
      }
      dispatch(requestDenyDatasetListFailure("API error"));
    }
  };
};

export const feedbackServiceRequest = (payload) => {
  return async (dispatch) => {
    dispatch(FeedbackServiceApiRequest());
    try {
      const response = await chatFeedbackService(payload);
      dispatch(FeedbackServiceApiSuccess(response));
    } catch (error) {
      if (error.response.status === 400) {
        dispatch(FeedbackServiceApiFailure(error.response));
      } else {
        dispatch(AdduserRequestFailure("API error"));
      }
    }
  };
};

export const getDefaultFeedbackSuggestion = () => {
  return async (dispatch) => {
    dispatch(feedbackSuggestionRequest());
    try {
      const response = await getFeedbackSugestion();
      dispatch(feedbackSuggestionSuccess(response));
    } catch (error) {
      dispatch(feedbackSuggestionFailure("API error"));
    }
  };
};

export const getChatLikesCountAction = (conversationId) => {
  return async (dispatch) => {
    dispatch(chatCountRequest());
    try {
      const response = await getChatLikesCount(conversationId);
      dispatch(chatCountSuccess(response));
    } catch (error) {
      dispatch(chatCountFailure("API error"));
    }
  };
};

export const getChatLikesDislikeStatus = () => {
  return async (dispatch) => {
    dispatch(chatStatusRequest());
    try {
      const response = await getChatLikesStatus();
      dispatch(chatStatusSuccess(response));
    } catch (error) {
      dispatch(chatStatusFailure("API error"));
    }
  };
};
export const trainDocument = (payload, id, datasetId) => {
  return async (dispatch) => {
    dispatch(apiTrainRequest());
    try {
      const response = await trainDocumentRequest(payload, id, datasetId);
      dispatch(requestTrainSuccess(response));
    } catch (error) {
      dispatch(requestTrainFailure("API error"));
    }
  };
};

export const updateUser = (payload, userId) => {
  return async (dispatch) => {
    dispatch(UpdateUserApiRequest());
    try {
      const response = await UpdateUserDataB2c(payload, userId);
      dispatch(UpdateUserRequestSuccess(response));
    } catch (error) {
      if (error.response.status === 400) {
        dispatch(UpdateUserRequestSuccess(error.response));
      } else {
        dispatch(UpdateUserRequestFailure("API error"));
      }
    }
  };
};

export const getSummarizationDocUrl = (fileName, datasetId) => {
  return async (dispatch) => {
    dispatch(requestSummarizationDocUrl());
    try {
      const response = await summarizationPdfUrl(fileName, datasetId);
      dispatch(successSummarizationDocUrl(response));
    } catch (error) {
      dispatch(failureSummarizationUrl("API error"));
    }
  };
};

export const editDataset = (payload, id, isExternalFlag = false) => {
  return async (dispatch) => {
    dispatch(EditDatasetRequest());
    try {
      const response = await editDatasetApi(payload, id, isExternalFlag);
      dispatch(EditDatasetSuccess(response));
    } catch (error) {
      if (error.response?.status === 400) {
        dispatch(EditDatasetSuccess(error.response));
      } else {
        dispatch(EditDatasetFailure("API error"));
      }
    }
  };
};


const createPromptRequest = () => ({
  type: CREATE_PROMPT_REQUEST,
});

const createPromptSuccess = (prompt) => ({
  type: CREATE_PROMPT_SUCCESS,
  payload: prompt,
});

const createPromptFailure = (error) => ({
  type: CREATE_PROMPT_FAILURE,
  payload: error,
});

export const createPrompt = (payload, datasetId) => {
  return async (dispatch) => {
    dispatch(createPromptRequest());
    try {
      const response = await createPromptAPI(payload, datasetId);
      dispatch(createPromptSuccess(response));
    } catch (error) {
      dispatch(createPromptFailure(error.message));
    }
  };
};

const updatePromptRequest = () => ({
  type: UPDATE_PROMPT_REQUEST,
});

const updatePromptSuccess = (prompt) => ({
  type: UPDATE_PROMPT_SUCCESS,
  payload: prompt,
});

const updatePromptFailure = (error) => ({
  type: UPDATE_PROMPT_FAILURE,
  payload: error,
});

export const updatePrompt = (payload, datasetId) => {
  return async (dispatch) => {
    dispatch(updatePromptRequest());
    try {
      const response = await updatePromptAPI(payload, datasetId);
      dispatch(updatePromptSuccess(response));
    } catch (error) {
      dispatch(updatePromptFailure(error.message));
    }
  };
};

// Action Creators
export const createDocSettingsRequest = () => ({
  type: CREATE_DOC_SETTINGS_REQUEST,
});

export const createDocSettingsSuccess = (data) => ({
  type: CREATE_DOC_SETTINGS_SUCCESS,
  payload: data,
});

export const createDocSettingsFailure = (error) => ({
  type: CREATE_DOC_SETTINGS_FAILURE,
  payload: error,
});

// Thunk Action
export const createDocSettings = (payload, datasetId) => {
  return async (dispatch) => {
    dispatch(createDocSettingsRequest());
    try {
      const response = await createDocSettingsAPI(payload, datasetId);
      dispatch(createDocSettingsSuccess(response));
    } catch (error) {
      dispatch(createDocSettingsFailure(error.message));
    }
  };
};

// Action Creators
export const fetchDocSettingsRequest = () => ({
  type: FETCH_DOC_SETTINGS_REQUEST,
});

export const fetchDocSettingsSuccess = (response) => ({
  type: FETCH_DOC_SETTINGS_SUCCESS,
  payload: response,
});

export const fetchDocSettingsFailure = (error) => ({
  type: FETCH_DOC_SETTINGS_FAILURE,
  payload: error,
});

// Thunk Action
export const fetchDocSettings = (datasetId, history = false) => {
  return async (dispatch) => {
    dispatch(fetchDocSettingsRequest());
    try {
      const response = await fetchDocSettingsAPI(datasetId, history);
      dispatch(fetchDocSettingsSuccess(response.data));
    } catch (error) {
      dispatch(fetchDocSettingsFailure(error));
    }
  };
};

export const updateDocSettingsRequest = () => ({
  type: UPDATE_DOC_SETTINGS_REQUEST,
});

export const updateDocSettingsSuccess = (data) => ({
  type: UPDATE_DOC_SETTINGS_SUCCESS,
  payload: data,
});

export const updateDocSettingsFailure = (error) => ({
  type: UPDATE_DOC_SETTINGS_FAILURE,
  payload: error,
});

export const updateDocSettings = (payload, datasetId) => {
  return async (dispatch) => {
    dispatch(updateDocSettingsRequest());
    try {
      const data = await updateDocSettingsAPI(payload, datasetId);
      dispatch(updateDocSettingsSuccess(data));
    } catch (error) {
      dispatch(updateDocSettingsFailure(error));
    }
  };
};

export const deletePromptParameterAndDatasetAction =
  (datasetId, isAssistants) => async (dispatch) => {
    dispatch({ type: DELETE_PROMPT_PARAMETER_DATASET_REQUEST });
    try {
      if (isAssistants) {
        await dispatch(deleteAssistantSettings(datasetId));
      } else {
        await dispatch(deletePromptAction(datasetId));
        await dispatch(deleteParameterAction(datasetId));
      }
      await dispatch(deleteDatasets(datasetId));
      dispatch({ type: DELETE_PROMPT_PARAMETER_DATASET_SUCCESS });
    } catch (error) {
      dispatch({
        type: DELETE_PROMPT_PARAMETER_DATASET_FAILURE,
        error: error.response ? error.response.data : "Unknown error",
      });
    }
  };

export const deleteParameterAction = (datasetId) => async (dispatch) => {
  dispatch({ type: DELETE_PARAMETER_REQUEST });
  try {
    const response = await deleteParameter(datasetId);
    dispatch({ type: DELETE_PARAMETER_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: DELETE_PARAMETER_FAILURE,
      error: error.response ? error.response.data : "Unknown error",
    });
  }
};

export const addEngagement = (payload) => async (dispatch) => {
  dispatch({ type: ADD_ENGAGEMENT_REQUEST });
  try {
    const response = await addEngagementAPI(payload);
    dispatch({ type: ADD_ENGAGEMENT_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: ADD_ENGAGEMENT_FAILURE, error });
  }
};

// Action Creators
export const fetchEngagementRequest = () => ({
  type: FETCH_ENGAGEMENT_REQUEST,
});

export const fetchEngagementSuccess = (data) => {
  return {
    type: FETCH_ENGAGEMENT_SUCCESS,
    payload: data,
  };
};

export const fetchEngagementFailure = (error) => ({
  type: FETCH_ENGAGEMENT_FAILURE,
  payload: error,
});

// Thunk Action to Fetch Engagement Data
export const fetchEngagement = (
  userId = null,
  datasetId = null,
  startDate = null,
  endDate = null
) => {
  return async (dispatch) => {
    dispatch(fetchEngagementRequest());
    try {
      // Pass ALL parameters including startDate and endDate
      const response = await getEngagementAPI(
        userId,
        datasetId,
        startDate,
        endDate
      );
      dispatch(fetchEngagementSuccess(response.data));
      return response.data;
    } catch (error) {
      console.error("Error fetching engagement data:", error);
      dispatch(fetchEngagementFailure(error.message));
      throw error;
    }
  };
};

export const humanAgentRegister = (payload) => {
  return async (dispatch) => {
    dispatch(CreateAgentRequest());
    try {
      const response = await registerHumanAgent(payload);
      dispatch(CreateAgentSuccess(response));
      return response; // allow callers to get agent details
    } catch (error) {
      dispatch(CreateAgentFailure("API error"));
      throw error;
    }
  };
};

export const humanAgentUpdateStatus = (agentId, payload) => {
  return async (dispatch) => {
    dispatch(UpdateAgentStatusRequest());
    try {
      const response = await updateHumanAgentStatus(agentId, payload);
      dispatch(UpdateAgentStatusSuccess(response));
    } catch (error) {
      dispatch(UpdateAgentStatusFailure("API error"));
    }
  };
};
export const humanAgentGetStatus = (agentId) => {
  return async (dispatch) => {
    dispatch(getAgentStatusRequest());
    try {
      const response = await getHumanAgentStatus(agentId);
      dispatch(getAgentStatusSuccess(response));
    } catch (error) {
      dispatch(getAgentStatusFailure("API error"));
    }
  };
};

export const humanAgentQna = (agentId, type, payload) => {
  return async (dispatch) => {
    dispatch(createQnaRequest());
    try {
      const response = await updateHumanAgentQna(agentId, type, payload);
      dispatch(createQnaSuccess(response.data));
    } catch (error) {
      dispatch(createQnaFailure("API error"));
    }
  };
};

export const getHumanAgentQnaChat = (agentId, type) => {
  return async (dispatch) => {
    dispatch(getHumanAgentQnaRequest());
    try {
      const response = await getHumanAgentQna(agentId, type);
      dispatch(getHumanAgentQnaSuccess(response.data));
    } catch (error) {
      dispatch(getHumanAgentQnaFailure("API error"));
    }
  };
};

export const humanAgentValidate = (agentId) => {
  return async (dispatch) => {
    dispatch(validateAgentRequest());
    try {
      const response = await validateHumanAgent(agentId);
      dispatch(validateAgentSuccess(response));
    } catch (error) {
      dispatch(validateAgentFailure("API error"));
    }
  };
};

export const configureHumanAgentEmail = (payload) => {
  return async (dispatch) => {
    dispatch(saveAgentEmailRequest());
    try {
      const response = await saveHumanAgentEmail(payload);
      dispatch(saveAgentEmailSuccess(response));
    } catch (error) {
      dispatch(saveAgentEmailFailure("API error"));
    }
  };
};

export const getAgentEmail = (datasetId) => {
  return async (dispatch) => {
    dispatch(getAgentEmailRequest());
    try {
      const response = await getHumanAgentEmail(datasetId);
      dispatch(getAgentEmailSuccess(response));
    } catch (error) {
      dispatch(getAgentEmailFailure("API error"));
    }
  };
};

export const deleteAgentEmail = (datasetId) => {
  return async (dispatch) => {
    dispatch(deleteAgentEmailRequest());
    try {
      const response = await deleteHumanAgentEmail(datasetId);
      dispatch(deleteAgentEmailSuccess(response));
    } catch (error) {
      dispatch(deleteAgentEmailFailure("API error"));
    }
  };
};

export const fetchAssistantParameters = (datasetId) => async (dispatch) => {
  dispatch({ type: FETCH_ASSISTANT_PARAMETERS_REQUEST });
  try {
    const data = await fetchAssistantParametersAPI(datasetId);
    dispatch({ type: FETCH_ASSISTANT_PARAMETERS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_ASSISTANT_PARAMETERS_FAILURE, error });
  }
};

export const saveAssistantParameters =
  (datasetId, payload) => async (dispatch) => {
    dispatch({ type: SAVE_ASSISTANT_PARAMETERS_REQUEST });
    try {
      const data = await saveAssistantParametersAPI(datasetId, payload);
      dispatch({ type: SAVE_ASSISTANT_PARAMETERS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: SAVE_ASSISTANT_PARAMETERS_FAILURE, error });
    }
  };

export const updateAssistantParameters =
  (datasetId, payload) => async (dispatch) => {
    dispatch({ type: UPDATE_ASSISTANT_PARAMETERS_REQUEST });
    try {
      const data = await updateAssistantParametersAPI(datasetId, payload);
      dispatch({ type: UPDATE_ASSISTANT_PARAMETERS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: UPDATE_ASSISTANT_PARAMETERS_FAILURE, error });
    }
  };

export const setIsAssistantDataset = (value) => {
  
  return {
    type: "SET_IS_ASSISTANT_DATASET",
    payload: value,
  };
};

export const deleteAssistantSettings = (datasetId) => async (dispatch) => {
  dispatch({ type: DELETE_ASSISTANT_SETTINGS_REQUEST });
  try {
    const response = await deleteAssistantSettingsAPI(datasetId);
    dispatch({
      type: DELETE_ASSISTANT_SETTINGS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: DELETE_ASSISTANT_SETTINGS_FAILURE, error });
  }
};

export const fetchCombinedData = (userId, chatMetaId) => async (dispatch) => {
  dispatch({ type: FETCH_COMBINED_DATA_REQUEST });
  try {
    const response = await fetchCombinedDataAPI(userId, chatMetaId);
    const data = await response.json();
    dispatch({ type: FETCH_COMBINED_DATA_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_COMBINED_DATA_FAILURE, payload: error.message });
  }
};

// Quick Chat Action Creators
export const createQuickChat = (type) => async (dispatch) => {
  dispatch({ type: CREATE_QUICK_CHAT_REQUEST });
  try {
    // The backend will automatically use the reference dataset (isReferenceDataset: true)
    // No need to fetch configurations from localStorage anymore
    

    const result = await createQuickChatDataset(type);
    dispatch({ type: CREATE_QUICK_CHAT_SUCCESS, payload: result });
    return result;
  } catch (error) {
    dispatch({ type: CREATE_QUICK_CHAT_FAILURE, payload: error.message });
    throw error;
  }
};

export const fetchInnferreToken = (uuid) => async (dispatch) => {
  dispatch({ type: FETCH_INNFERRE_TOKEN_REQUEST });
  try {
    const response = await validateExternalUUID(uuid);
    if (!response?.innferreToken) throw new Error("No token received");

    // Save to localStorage
    localStorage.setItem("token", response.innferreToken);
    localStorage.setItem("isExternalUser", "true");

    dispatch({
      type: FETCH_INNFERRE_TOKEN_SUCCESS,
      payload: response.innferreToken,
    });

    return response.innferreToken; // return for chaining
  } catch (error) {
    dispatch({
      type: FETCH_INNFERRE_TOKEN_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

// ✅ Step 2: Fetch dataset from dataset-service using token

// ✅ Step 2: Fetch dataset from dataset-service using token
export const fetchExternalDataset = (token) => async (dispatch) => {
  
  dispatch({ type: FETCH_EXTERNAL_DATASET_REQUEST });

  try {
    
    const datasetResponse = await getExternalDatasetAPI(token);

   

    const datasets = datasetResponse?.data;
    

    if (Array.isArray(datasets) && datasets.length > 0) {
      
      dispatch({
        type: FETCH_EXTERNAL_DATASET_SUCCESS,
        payload: datasets,
      });
      return datasets;
    } else {
      console.warn("[WARN] No datasets found in external dataset API");
      dispatch({
        type: FETCH_EXTERNAL_DATASET_SUCCESS,
        payload: [],
      });
      return [];
    }
  } catch (error) {
    console.error("[ERROR] fetchExternalDataset failed:", error);
    dispatch({
      type: FETCH_EXTERNAL_DATASET_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};




// Create QuickChat with specific reference configuration
export const createQuickChatWithReference =
  (type, referenceName) => async (dispatch) => {
    dispatch({ type: CREATE_QUICK_CHAT_REQUEST });
    try {
      const referenceConfigs = getReferenceDatasetConfigs();
      const referenceConfig = referenceConfigs[referenceName] || null;

      if (!referenceConfig) {
        throw new Error(`Reference configuration '${referenceName}' not found`);
      }

      console.log(
        "Creating QuickChat with specific reference configuration:",
        referenceName
      );
      const result = await createQuickChatDataset(type, referenceConfig);
      dispatch({ type: CREATE_QUICK_CHAT_SUCCESS, payload: result });
      return result;
    } catch (error) {
      dispatch({ type: CREATE_QUICK_CHAT_FAILURE, payload: error.message });
      throw error;
    }
  };

// Create QuickChat with default configuration (bypass reference)
export const createQuickChatWithDefaults = (type) => async (dispatch) => {
  dispatch({ type: CREATE_QUICK_CHAT_REQUEST });
  try {
    console.log(
      "Creating QuickChat with default configuration (bypassing reference)"
    );
    const result = await createQuickChatDataset(type, null);
    dispatch({ type: CREATE_QUICK_CHAT_SUCCESS, payload: result });
    return result;
  } catch (error) {
    dispatch({ type: CREATE_QUICK_CHAT_FAILURE, payload: error.message });
    throw error;
  }
};

// Groups Action Types
export const GET_GROUPS_REQUEST = "GET_GROUPS_REQUEST";
export const GET_GROUPS_SUCCESS = "GET_GROUPS_SUCCESS";
export const GET_GROUPS_FAILURE = "GET_GROUPS_FAILURE";

export const CREATE_GROUP_REQUEST = "CREATE_GROUP_REQUEST";
export const CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS";
export const CREATE_GROUP_FAILURE = "CREATE_GROUP_FAILURE";

export const UPDATE_GROUP_REQUEST = "UPDATE_GROUP_REQUEST";
export const UPDATE_GROUP_SUCCESS = "UPDATE_GROUP_SUCCESS";
export const UPDATE_GROUP_FAILURE = "UPDATE_GROUP_FAILURE";

export const DELETE_GROUP_REQUEST = "DELETE_GROUP_REQUEST";
export const DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS";
export const DELETE_GROUP_FAILURE = "DELETE_GROUP_FAILURE";

export const GET_GROUP_USERS_REQUEST = "GET_GROUP_USERS_REQUEST";
export const GET_GROUP_USERS_SUCCESS = "GET_GROUP_USERS_SUCCESS";
export const GET_GROUP_USERS_FAILURE = "GET_GROUP_USERS_FAILURE";

// Groups Actions
export const getGroups = () => async (dispatch) => {
  dispatch({ type: GET_GROUPS_REQUEST });
  try {
    const response = await getGroupsData();
    dispatch({ type: GET_GROUPS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: GET_GROUPS_FAILURE, payload: error.message });
  }
};

export const createGroup = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_GROUP_REQUEST });
  try {
    const response = await createGroupData(payload);
    dispatch({ type: CREATE_GROUP_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: CREATE_GROUP_FAILURE, payload: error.message });
  }
};

export const updateGroup = (groupId, payload) => async (dispatch) => {
  dispatch({ type: UPDATE_GROUP_REQUEST });
  try {
    const response = await updateGroupData(groupId, payload);
    dispatch({ type: UPDATE_GROUP_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: UPDATE_GROUP_FAILURE, payload: error.message });
  }
};

export const deleteGroup = (groupId) => async (dispatch) => {
  dispatch({ type: DELETE_GROUP_REQUEST });
  try {
    const response = await deleteGroupData(groupId);
    dispatch({ type: DELETE_GROUP_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: DELETE_GROUP_FAILURE, payload: error.message });
  }
};

export const getGroupUsers = (groupId) => async (dispatch) => {
  dispatch({ type: GET_GROUP_USERS_REQUEST });
  try {
    const response = await getGroupUsersData(groupId);
    dispatch({ type: GET_GROUP_USERS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: GET_GROUP_USERS_FAILURE, payload: error.message });
  }
};

// Success action creators for resetting state
export const GetGroupsSuccess = (payload) => ({
  type: GET_GROUPS_SUCCESS,
  payload,
});

export const CreateGroupSuccess = (payload) => ({
  type: CREATE_GROUP_SUCCESS,
  payload,
});

export const UpdateGroupSuccess = (payload) => ({
  type: UPDATE_GROUP_SUCCESS,
  payload,
});

export const DeleteGroupSuccess = (payload) => ({
  type: DELETE_GROUP_SUCCESS,
  payload,
});

// Token Usage Action Types
export const SAVE_TOKEN_USAGE_REQUEST = "SAVE_TOKEN_USAGE_REQUEST";
export const SAVE_TOKEN_USAGE_SUCCESS = "SAVE_TOKEN_USAGE_SUCCESS";
export const SAVE_TOKEN_USAGE_FAILURE = "SAVE_TOKEN_USAGE_FAILURE";

export const GET_TOKEN_USAGE_REQUEST = "GET_TOKEN_USAGE_REQUEST";
export const GET_TOKEN_USAGE_SUCCESS = "GET_TOKEN_USAGE_SUCCESS";
export const GET_TOKEN_USAGE_FAILURE = "GET_TOKEN_USAGE_FAILURE";

export const GET_TOKEN_SUMMARY_REQUEST = "GET_TOKEN_SUMMARY_REQUEST";
export const GET_TOKEN_SUMMARY_SUCCESS = "GET_TOKEN_SUMMARY_SUCCESS";
export const GET_TOKEN_SUMMARY_FAILURE = "GET_TOKEN_SUMMARY_FAILURE";

export const GET_TOKEN_DAILY_REQUEST = "GET_TOKEN_DAILY_REQUEST";
export const GET_TOKEN_DAILY_SUCCESS = "GET_TOKEN_DAILY_SUCCESS";
export const GET_TOKEN_DAILY_FAILURE = "GET_TOKEN_DAILY_FAILURE";

export const GET_TOKEN_BY_MODEL_REQUEST = "GET_TOKEN_BY_MODEL_REQUEST";
export const GET_TOKEN_BY_MODEL_SUCCESS = "GET_TOKEN_BY_MODEL_SUCCESS";
export const GET_TOKEN_BY_MODEL_FAILURE = "GET_TOKEN_BY_MODEL_FAILURE";

export const GET_TOKEN_BY_USER_REQUEST = "GET_TOKEN_BY_USER_REQUEST";
export const GET_TOKEN_BY_USER_SUCCESS = "GET_TOKEN_BY_USER_SUCCESS";
export const GET_TOKEN_BY_USER_FAILURE = "GET_TOKEN_BY_USER_FAILURE";

// Token Usage Action Creators
export const saveTokenUsageRequest = () => ({
  type: SAVE_TOKEN_USAGE_REQUEST,
});

export const saveTokenUsageSuccess = (data) => ({
  type: SAVE_TOKEN_USAGE_SUCCESS,
  payload: data,
});

export const saveTokenUsageFailure = (error) => ({
  type: SAVE_TOKEN_USAGE_FAILURE,
  payload: error,
});

export const getTokenUsageRequest = () => ({
  type: GET_TOKEN_USAGE_REQUEST,
});

export const getTokenUsageSuccess = (data) => ({
  type: GET_TOKEN_USAGE_SUCCESS,
  payload: data,
});

export const getTokenUsageFailure = (error) => ({
  type: GET_TOKEN_USAGE_FAILURE,
  payload: error,
});

// Token Summary Action Creators
export const getTokenSummaryRequest = () => ({
  type: GET_TOKEN_SUMMARY_REQUEST,
});

export const getTokenSummarySuccess = (data) => ({
  type: GET_TOKEN_SUMMARY_SUCCESS,
  payload: data,
});

export const getTokenSummaryFailure = (error) => ({
  type: GET_TOKEN_SUMMARY_FAILURE,
  payload: error,
});

// Token Daily Action Creators
export const getTokenDailyRequest = () => ({
  type: GET_TOKEN_DAILY_REQUEST,
});

export const getTokenDailySuccess = (data) => ({
  type: GET_TOKEN_DAILY_SUCCESS,
  payload: data,
});

export const getTokenDailyFailure = (error) => ({
  type: GET_TOKEN_DAILY_FAILURE,
  payload: error,
});

// Token By Model Action Creators
export const getTokenByModelRequest = () => ({
  type: GET_TOKEN_BY_MODEL_REQUEST,
});

export const getTokenByModelSuccess = (data) => ({
  type: GET_TOKEN_BY_MODEL_SUCCESS,
  payload: data,
});

export const getTokenByModelFailure = (error) => ({
  type: GET_TOKEN_BY_MODEL_FAILURE,
  payload: error,
});

// Token By User Action Creators
export const getTokenByUserRequest = () => ({
  type: GET_TOKEN_BY_USER_REQUEST,
});

export const getTokenByUserSuccess = (data) => ({
  type: GET_TOKEN_BY_USER_SUCCESS,
  payload: data,
});

export const getTokenByUserFailure = (error) => ({
  type: GET_TOKEN_BY_USER_FAILURE,
  payload: error,
});

// Token Usage Thunk Actions
export const saveTokenUsageAction = (payload) => async (dispatch) => {
  dispatch(saveTokenUsageRequest());
  try {
    const response = await saveTokenUsage(payload);
    
    if (response.data && response.data.success) {
      dispatch(saveTokenUsageSuccess(response.data));
      return response;
    } else {
      throw new Error(response.data?.error || 'Token usage save failed');
    }
  } catch (error) {
    dispatch(saveTokenUsageFailure(error.message));
    console.error('Token usage save error:', error);
    return { data: { success: false, error: error.message } };
  }
};

export const getTokenUsageStatsAction = (chatId) => async (dispatch) => {
  dispatch(getTokenUsageRequest());
  try {
    const response = await getTokenUsageStats(chatId);
    dispatch(getTokenUsageSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getTokenUsageFailure(error.message));
    console.error('Get token usage stats error:', error);
    throw error;
  }
};

// Token Usage Summary
export const getTokenUsageSummaryAction = (startDate, endDate, orgKey, datasetId, userId) => async (dispatch) => {
  dispatch(getTokenSummaryRequest());
  try {
    const response = await getTokenUsageSummary(startDate, endDate, orgKey, datasetId, userId);
    dispatch(getTokenSummarySuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getTokenSummaryFailure(error.message));
    throw error;
  }
};

// Token Usage Daily
export const getTokenUsageDailyAction = (startDate, endDate, orgKey, datasetId, userId) => async (dispatch) => {
  dispatch(getTokenDailyRequest());
  try {
    const response = await getTokenUsageDaily(startDate, endDate, orgKey, datasetId, userId);
    dispatch(getTokenDailySuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getTokenDailyFailure(error.message));
    throw error;
  }
};

// Token Usage By Model
export const getTokenUsageByModelAction = (startDate, endDate, orgKey, datasetId, userId) => async (dispatch) => {
  dispatch(getTokenByModelRequest());
  try {
    const response = await getTokenUsageByModel(startDate, endDate, orgKey, datasetId, userId);
    dispatch(getTokenByModelSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getTokenByModelFailure(error.message));
    throw error;
  }
};

// Token Usage By User
export const getTokenUsageByUserAction = (startDate, endDate, orgKey, datasetId, userId, limit = 10) => async (dispatch) => {
  dispatch(getTokenByUserRequest());
  try {
    const response = await getTokenUsageByUser(startDate, endDate, orgKey, datasetId, userId, limit);
    dispatch(getTokenByUserSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getTokenByUserFailure(error.message));
    throw error;
  }
};

// Token Usage Recent
// Token Usage By Organization
export const getTokenUsageByOrgAction = (startDate, endDate, orgKey, datasetId, userId) => async (dispatch) => {
  dispatch(getTokenUsageRequest());
  try {
    const response = await getTokenUsageByOrg(startDate, endDate, orgKey, datasetId, userId);
    dispatch(getTokenUsageSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getTokenUsageFailure(error.message));
    throw error;
  }
};
